
const getToken = state => state.token

export default {
  getToken
}



// WEBPACK FOOTER //
// ./src/store/modules/memed/getters.js